








import { Component, Vue, Inject } from "vue-property-decorator";
import { IBulkActionProvider } from "@/models/providers/bulkAction";

@Component({
  components: {
    "bulk-action-results-table": () =>
      import("@/components/app/admin/automation/bulkActionsResultsTable.vue")
  }
})
export default class CProdBulkActionLogs extends Vue {
  @Inject({ from: "bulkActionProvider" })
  public bulkActionProvider!: () => IBulkActionProvider;

  public get $bulkActionData() {
    return this.bulkActionProvider();
  }
}
